export default "__VITE_ASSET__CcTcgt0$__"